import { render, staticRenderFns } from "./ResumoRegistroVacinacao.vue?vue&type=template&id=652e4150&scoped=true&"
import script from "./ResumoRegistroVacinacao.vue?vue&type=script&lang=js&"
export * from "./ResumoRegistroVacinacao.vue?vue&type=script&lang=js&"
import style0 from "./ResumoRegistroVacinacao.vue?vue&type=style&index=0&id=652e4150&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e4150",
  null
  
)

export default component.exports